import BaseService from './BaseService'
import { IUser } from '../models/api/User'

class UsersService extends BaseService {
  constructor(baseUrl: string) {
    super(baseUrl)
  }
  search = (
    companyId,
    skip?,
    limit?,
    query?,
    role?: 'admin' | 'user',
    type?: 'agency' | 'account',
    locationId?: string
  ) =>
    this.requests.get('/search', {
      params: {
        companyId,
        query,
        role,
        type,
        locationId,
        limit,
        skip,
      },
    })
  delete = (userId: string) => {
    if (!userId) throw new Error('Invalid User ID');
    return this.requests.delete(`/${userId}`)
  }
  update = (userId: string, body: IUser) => {
    if (!userId) throw new Error('Invalid User ID');
    return this.requests.put(`/${userId}`, body)
  }
  create = (body:IUser) => this.requests.post(`/`, body)
  getByLocationId = (locationId:string) => this.requests.get(`/?locationId=${locationId}`)
  read = (userId: string) => {
    if (!userId) throw new Error('Invalid User ID');
    return this.requests.get(`/${userId}`)
  }
}

const instance = new UsersService(BaseService.servicesConfig.Users)

export default instance